import { Combobox, ComboboxInput, type ComboboxInputProps } from '@zillow/constellation';
import { type ComponentProps, type FocusEventHandler, forwardRef, type Ref } from 'react';

/**
 * Constellation Combobox has a bug that prevents the onBlur callback to be
 * passed to the input component. This prevents combobox fields to be
 * validated when the form validation mode is "onBlur". This is a workaround.
 */

type ComboBoxFixProps = ComponentProps<typeof Combobox> & {
  onBlur?: FocusEventHandler<HTMLInputElement>;
  name?: string;
};

export const ComboBoxFix = forwardRef<HTMLInputElement, ComboBoxFixProps>(function ComboBoxFix(
  { onBlur, name, ...props },
  ref,
) {
  return (
    <Combobox
      {...props}
      renderInput={(inputProps: ComboboxInputProps & { onBlur?: FocusEventHandler<HTMLInputElement> }) => (
        <ComboboxInput
          {...(inputProps as ComponentProps<typeof ComboboxInput>)}
          ref={ref as Ref<HTMLInputElement>}
          name={name}
          onBlur={(ev) => {
            inputProps.onBlur?.(ev);
            onBlur?.(ev);
          }}
        />
      )}
    />
  );
});
